/**
 * Raflr Logo - Ticket Stub Design
 *
 * A modern ticket stub silhouette with bold "R".
 * The notched edges evoke competition entries while
 * maintaining a clean, professional look.
 *
 * Features bounce-in animation on load and subtle hover scale.
 */
export default function Logo({ size = 'md', showText = true, className = '' }) {
  const sizes = {
    sm: { icon: 'w-7 h-7', text: 'text-lg' },
    md: { icon: 'w-8 h-8', text: 'text-xl' },
    lg: { icon: 'w-10 h-10', text: 'text-2xl' },
    xl: { icon: 'w-14 h-14', text: 'text-3xl' },
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-1.5 group ${className}`}>
      {/* Ticket stub icon with R - bounces on load */}
      <div
        className={`${icon} relative transition-transform duration-200 ease-out group-hover:scale-110`}
        style={{
          animation: 'logoBounce 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
      >
        <svg
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full drop-shadow-sm"
        >
          {/* Ticket stub shape with notches */}
          <path
            d="M4 6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V12C26.3431 12 25 13.3431 25 15C25 16.6569 26.3431 18 28 18V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V18C5.65685 18 7 16.6569 7 15C7 13.3431 5.65685 12 4 12V6Z"
            fill="#14B8A6"
          />

          {/* Bold R letter */}
          <text
            x="16"
            y="21"
            textAnchor="middle"
            fill="white"
            fontSize="16"
            fontWeight="bold"
            fontFamily="system-ui, -apple-system, sans-serif"
          >
            R
          </text>
        </svg>
      </div>

      {/* Text - slides in with delay */}
      {showText && (
        <span
          className={`font-display font-semibold ${text} text-cream tracking-tight transition-colors duration-200 group-hover:text-primary-light`}
          style={{
            animation: 'logoText 0.5s ease-out 0.15s both',
          }}
        >
          raflr
        </span>
      )}
    </div>
  );
}

/**
 * Compact logo icon only (for favicon, app icon, etc.)
 */
export function LogoIcon({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Ticket stub shape with notches */}
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V12C26.3431 12 25 13.3431 25 15C25 16.6569 26.3431 18 28 18V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V18C5.65685 18 7 16.6569 7 15C7 13.3431 5.65685 12 4 12V6Z"
        fill="#14B8A6"
      />

      {/* Bold R letter */}
      <text
        x="16"
        y="21"
        textAnchor="middle"
        fill="white"
        fontSize="16"
        fontWeight="bold"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        R
      </text>
    </svg>
  );
}
